// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e87c5a7d","115":"51800297","949":"10c4ce32"}[chunkId] + ".chunk.js";
};